// extracted by mini-css-extract-plugin
export default {"title":"Title_title__Hu4yl","subtitle":"Title_subtitle__5dFVP"};